import { Key } from 'react'
import Styles from '../Search.module.scss'
import { Menu } from 'components/Menu/Menu'
import { Item, Section as StatelySection } from '@react-stately/collections'
import { Grid, Menu6 as List } from 'blaze-ui/icons'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Button } from 'blaze-ui/Button'
import { ButtonSize } from 'blaze-ui/Button/Types'

export type ViewType = 'Grid' | 'List'

interface Props {
  onSelect: (viewType: ViewType) => void
  viewType: ViewType
  withLabel?: boolean
  size?: ButtonSize
}

export const ViewDropdown = ({ onSelect, viewType, withLabel = false, size = 'lg' }: Props) => {
  return (
    <DropdownTrigger placement="bottom-start" popoverClassName={Styles.popover}>
      {withLabel ? (
        <Button variant="tertiary" frontIcon={viewType === 'Grid' ? Grid : List} withChevron="down" size={size}>
          {viewType} View
        </Button>
      ) : (
        <IconButton variant="tertiary" icon={viewType === 'Grid' ? Grid : List} size={size} />
      )}
      {(close) => (
        <Menu
          onAction={(key: Key) => {
            onSelect(key as ViewType)
            close()
          }}
          className={Styles.menu}
          aria-label="View menu"
          itemClassName={Styles.menuItem}
          selectionMode="single"
          selectedKeys={new Set([viewType])}
        >
          <StatelySection>
            <Item key="Grid" textValue="Grid">
              <Grid /> Grid
            </Item>
            <Item key="List" textValue="List">
              <List /> List
            </Item>
          </StatelySection>
        </Menu>
      )}
    </DropdownTrigger>
  )
}
